import React, { useState } from "react";

import Form from "./Form";
import Success from "./Success";

import classes from "./PasswordReset.module.css";

const PasswordReset = () => {
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState(null);

  const onFormSuccess = (email) => {
    setSuccess(true);
    setEmail(email);
  };

  return (
    <div className={classes.PasswordReset}>
      <h1>Reset password</h1>
      {success ? <Success email={email} /> : <Form onSuccess={onFormSuccess} />}
    </div>
  );
};

export default PasswordReset;
